import { useQueryClient } from '@tanstack/react-query';
import { useDialogs } from '@toolpad/core/useDialogs';

import { useGetPackage } from 'api/hooks/private/packages/GetPackage';
import { useUpdateEmailTemplate } from 'api/hooks/private/templates/UpdateEmailTemplate';

import FeedbackDialog from 'components/Dialogs/FeedbackDialog';
import { RichTextEditorProvider } from 'components/Editor/RichTextEditor/RichTextEditorProvider';
import EmailTemplateForm, { EmailTemplateOutputValues } from 'components/TemplateForms';

import { getApiErrorMessage } from 'utils/getApiErrorMessage';

interface EmailTemplateProps {
  packageId: string;
}

export function WelcomeLetter({ packageId }: EmailTemplateProps) {
  const dialogs = useDialogs();
  const queryClient = useQueryClient();
  const updateEmailTemplate = useUpdateEmailTemplate();

  // fetch the package
  const pkg = useGetPackage({
    variables: {
      id: packageId,
    },
    enabled: !!packageId,
  });

  const onSubmit = async (data: EmailTemplateOutputValues) => {
    try {
      // show confirmation dialog
      const confirmed = await dialogs.confirm(`Update welcome letter for "${pkg.data?.name}"?`, {
        okText: 'Update',
        cancelText: 'Cancel',
      });

      // if user cancels, return
      if (!confirmed) {
        return;
      }

      const result = await updateEmailTemplate.mutateAsync({
        templateKey: 'welcome-letter',
        id: packageId,
        template: data,
      });

      if (result) {
        // close the dialog
        // handleClose();

        // invalidate the query key
        queryClient.invalidateQueries({
          queryKey: ['package', { id: packageId }],
        });

        // show success message
        dialogs.open(FeedbackDialog, {
          icon: 'success',
          title: 'Welcome Letter Updated',
        });
      }

      // const editorState = editor.getEditorState();
      // console.log(editorState.toJSON());
    } catch (error) {
      dialogs.open(FeedbackDialog, {
        title: 'Error',
        message: getApiErrorMessage(error),
      });
    }
  };
  return (
    <RichTextEditorProvider>
      <EmailTemplateForm templateKey="welcome-letter" id={packageId} onSubmit={onSubmit} />
    </RichTextEditorProvider>
  );
}

export default WelcomeLetter;
